var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#17181E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V32H32V0H0ZM26.4081 27.7841L20.3849 24.7472L20.4302 18.9024L8.86834 18.9477L11.6816 20.329L11.6364 27.7841L5.74632 24.7472V4.21326L11.7242 7.11703L11.679 12.9166H20.3823V4.21326L26.4081 7.16227V27.7841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d104d027698323420aefd29315f3efb4.svg";
export { ForwardRef as ReactComponent };